module.exports = {"TXTINT_BRAND_BetStars":{"id":"TXTINT_BRAND_BetStars","defaultMessage":"PokerStars Sports撲克之星體育博彩"}}